import { Injectable } from '@angular/core';
import { CalculationSettingsModel, RNAVModel } from '../models/configuration';
import { CoordinatePointModel } from '../models/coordinate-point';
import { HorizonRecord } from '../models/HorizonRecord';
import { PerformanceAnalysisDTO } from '../models/performanceAnalysisDTO';
import { CalculationsService } from './calculations.service';
import { ConfigurationService } from './configuration.service';
import { MapService } from './map.service';
import { ToolsControlService } from './tools-control.service';
import olMap from 'ol/Map';
import { EventsKey } from 'ol/events';
import { PointsService } from './points.service';
import { HorizonDataResult, HorizonSampRingResult, IndexedSummitsResult, SampPointResult } from '../models/horizonToolModel';
import { VicentyToolControlService } from './vicenty-tool-control.service';
import LineString from 'ol/geom/LineString';
import { Coordinate } from 'ol/coordinate';
import OlFeature from 'ol/Feature';
import { Circle, Fill, Style } from 'ol/style';
import Polygon from 'ol/geom/Polygon';
import * as olProj from 'ol/proj';
import Point from 'ol/geom/Point';
import { ColorLike } from 'ol/colorlike';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { UtilsService } from './utils.service';
import { DynamicTable } from '../popup/dynamic-table/dynamic-table.component';
import Feature from 'ol/Feature';
import { Chart } from 'chart.js';
import { getRelativePosition } from 'chart.js/helpers';
import { Interaction } from 'chart.js';
import { FeatureType } from '../models/EnumTypes';
import { ModalControlService } from './modal-control.service';
import { SearchItem } from '../models/searchItem';
import { SearchService } from './search.service';
import { GlobalSelectionControlService } from '../map/services/global-selection-control.service';
import {unByKey} from 'ol/Observable';
import { ModalConfirmationService } from './modal-confirmation.service';
import { CoordenateService } from './coordenate.service';
import { CrossSectionService } from './cross-section.service';
import { InteractionModeFunction } from 'chart.js';
import { ProgressService } from './progress.service';

declare module 'chart.js' {
  interface InteractionModeMap {
    myCustomModeHorizonTool: InteractionModeFunction;
  }
}

@Injectable({
  providedIn: 'root'
})


export class HorizonToolService {

  active : boolean;
  fullScreenMode : boolean = false;
  horizonModal : HorizonRecord = new HorizonRecord();
  map : olMap;
  eventKey: EventsKey;
  clickedCoordinates : CoordinatePointModel = new CoordinatePointModel();
  ellipsePoints:  Coordinate[] = [];
  internalEllipsePoints: Coordinate[] = [];
  ctx: HTMLCanvasElement;
  clicked: boolean = false;
  crossSectionEnabled = false;


  horizonData: HorizonDataResult;

  minScreeningAngles = [];

  chart: Chart;

  errorMessage = [null,null,null,null];

  useScreening = false;
  linePositionOnChart: number;
  selectedNavaid : any;


  constructor(
    private toolsService: ToolsControlService,
    private configurationService : ConfigurationService,
    private calculationService : CalculationsService,
    public mapService: MapService,
    public pointsController: PointsService,
    private vicentyTool: VicentyToolControlService,
    private popupService : BsModalService,
    private utilsService : UtilsService,
    public modalService: ModalControlService,
    private searchService : SearchService,
    private globalSelectionService: GlobalSelectionControlService,
    private confirmationModalService : ModalConfirmationService,
    private rcsControl : CoordenateService,
    private crossSectionService : CrossSectionService,
    public progressService: ProgressService

  ) {
    this.map = this.mapService.getMap('map');
    this.progressService.performHorizonTool = (data) => this.resumePerformHorizonTool(data);
  }

  validateParameters() : boolean{
    for(let error of this.errorMessage){
      if (error != null){
        this.modalService.showMesssageModal("Horizon Tool", error);
        return false;
      }
    }
    return true;
  }

  openWindow():void {
    this.active = true;
    this.toolsService.navigationOnTop = true;

    if(this.chart == null){
      this.createHorizonGraph();
    }

    // on double click values
    this.eventKey = this.map.on('dblclick', async event => {
      if (this.progressService.horizonToolLoading == false && this.validateParameters()){
        this.progressService.horizonToolLoading = true;
        var coords = olProj.toLonLat(event.coordinate,this.rcsControl.activeRCS.isactive? this.rcsControl.activeRCS.epsg : "EPSG:3857");
        var lat = Math.round(coords[1] * 100000) / 100000;
        var lon = Math.round(coords[0] * 100000) / 100000;
        (await this.pointsController.getTerrainElevation(lat, lon)).subscribe(
          (data) => {
            this.horizonModal.terrainElevation = data;
          }
        );
        this.horizonModal.centerLatitude = lat;
        this.horizonModal.centerLongitude = lon;
        this.horizonModal.centerLatLonDms.fromLat(lat);
        this.horizonModal.centerLatLonDms.fromLon(lon);
        this.minScreeningAngles = [];
        this.selectedNavaid = undefined;
        // get all near navaids and perform horizon tool
        this.getNearNavaidsAndExecute();
      }
    });
  }

  private getNearNavaidsAndExecute() {
    this.crossSectionEnabled = true;
    var selectNavaids: Feature[] = [];

    if(this.selectedNavaid != undefined){
      this.useNavaidActualScreeningAngle(this.useScreening,this.selectedNavaid);
      return;
    }

    this.pointsController.getAllNavaidsFeaturesFromLayers().forEach((element) => {

      let coordinate = [element.getProperties().longitude, element.getProperties().latitude];
      let centerCoordinate = [this.horizonModal.centerLongitude, this.horizonModal.centerLatitude];
      // convert to current CRS
      coordinate = olProj.transform(coordinate, 'EPSG:4326',this.map.getView().getProjection());
      centerCoordinate = olProj.transform(centerCoordinate, 'EPSG:4326',this.map.getView().getProjection());
      // convert to Pixel
      var pixelNavaid = this.map.getPixelFromCoordinate(coordinate);
      var pixelCenter = this.map.getPixelFromCoordinate(centerCoordinate);

      var distance = Math.hypot(Math.abs(pixelNavaid[0] - pixelCenter[0]), Math.abs(pixelNavaid[1] - pixelCenter[1]));
      // filter near navaids
      if (distance < 13) {
        selectNavaids.push(element);
      }
    })
    if (selectNavaids.length > 0){
      // open popup to select one navaid from near navaids
      const bsModalRef : BsModalRef = this.popupService.show(DynamicTable, {
        backdrop: 'static' // Prevent closing on backdrop click
      });
      bsModalRef.content.entity = "Navaids";
      bsModalRef.content.type = "Horizon Tool Select";
      bsModalRef.content.selectAllActive = false;
      bsModalRef.content.data = selectNavaids;
      bsModalRef.content.displayedColumns = this.utilsService.getDynamicTableColumns("Navaids");
      bsModalRef.content.wasCanceled.subscribe(wasCanceled => {
        if (wasCanceled){
          this.performHorizonTool();
        } else {
          bsModalRef.content.onClose.subscribe(result => {
            if(result.length>0){
              this.selectedNavaid = result[0];
              if (result[0].MinScreeningAngle.length>0){
                this.confirmationModalService.showMesssageConfirmationModal("Use Actual Screening Angle", "The selected navaid has one or more Actual Screening Angle. Do you want to display them?", "Yes", "No",
                () => this.useNavaidActualScreeningAngle(true, result[0]), () => this.useNavaidActualScreeningAngle(false, result[0]));
              } else {
                this.useNavaidActualScreeningAngle(false, result[0]);
              }
            } else {
              this.performHorizonTool();
            }
          });
        }
      });
    } else {
      this.performHorizonTool();
    }
  }

  private useNavaidActualScreeningAngle(useAngle: boolean, navaid: any){
    this.useScreening = false;
    if (useAngle){
      this.minScreeningAngles = navaid.MinScreeningAngle;
      this.useScreening = true;
    }
    this.horizonModal.centerLatitude = navaid.Latitude;
    this.horizonModal.centerLongitude = navaid.Longitude;
    this.horizonModal.centerLatLonDms.fromLat(navaid.Latitude);
    this.horizonModal.centerLatLonDms.fromLon(navaid.Longitude);
    this.performHorizonTool();
  }

  createHorizonGraph(){
    Interaction.modes.myCustomModeHorizonTool = function(chart, e, options, useFinalPosition) {
      const position = getRelativePosition(e, chart);
      var correctDataSetIndex = null;
      const items = [];
      Interaction.evaluateInteractionItems(chart, 'x', position, (element, datasetIndex, index) => {
        const dataX = chart.scales.x.getValueForPixel(position.x);
        const dataY = chart.scales.y.getValueForPixel(position.y);
        if ( dataX > 0 && dataX < 359.7 && items.length < 1 && correctDataSetIndex != -1){
          if (correctDataSetIndex == null ) {
            if (!this.clicked){
              this.drawTrackLine(dataX);
            }
            let datasets = chart.data.datasets;
            var i = 0;
            while (correctDataSetIndex == null && i < datasets.length){
              if ( dataX > 0 && dataX < 359.7 && datasets[i].data[Math.floor(dataX/0.3)] > dataY ){
                correctDataSetIndex = i;
              }
              i++;
              if (i == datasets.length){
                correctDataSetIndex = -1;
              }
            }
          }
          if (element.inXRange(position.x, useFinalPosition) && datasetIndex == correctDataSetIndex    ) {
            items.push({element, datasetIndex, index});
          }
        }
      });
      return items;
    }.bind(this);

    const thisObject = this;
    const drawVerticalLinePlugins = {
      id: 'verticalLine',
      afterEvent(chart, args, pluginsOptions) {
        const xCursor = args.event.x;
        const click = args.event.type;
        if (click === 'click'){
          if (thisObject.clicked == false){
            thisObject.clicked = true;
            thisObject.linePositionOnChart = xCursor;
          } else {
            thisObject.clicked = false;
          }
          chart.update();
        }
      },
      afterDatasetsDraw(chart, args, pluginsOptions){
        const { ctx, chartArea: {top, bottom} } = chart;
        class Line {
          width: any;
          constructor(xCoor) {
            this.width = xCoor;
          };
          draw(ctx) {
            ctx.restore();
            ctx.beginPath();
            ctx.lineWidth = 2;
            ctx.strokeStyle = 'rgba(0,0,0) ';
            ctx.moveTo(this.width, top);
            ctx.lineTo(this.width, bottom);
            ctx.stroke();
            ctx.save();
          }
        }
        if (thisObject.clicked){
          let drawLine = new Line(thisObject.linePositionOnChart);
          drawLine.draw(ctx);
        }

      }

    }

    this.chart = new Chart(this.ctx, {
      type: 'line',
      data: null,
      plugins: [drawVerticalLinePlugins],
      options: {
        responsive: true,
        plugins:  {
          legend: {
            display: false
          },
          tooltip: {
            displayColors: false,
            callbacks: {
              label: function(context) {
                  let label = context.dataset.label || '';

                  if (label) {
                      label += ': ';
                  }
                  if (context.parsed.y !== null) {
                      label += "Elevation Angle: " + context.parsed.y ;
                  }
                  return label;
              },
              title: function(context) {
                return "Azimuth: " + context[0].parsed.x;
              },

            }
          },
        },
        interaction: {
          mode: 'myCustomModeHorizonTool',
          intersect: false
        },
        scales: {
          x: {
            grid: {display: false},
            type: 'linear',
            stacked: false,
            title: {
              display: true,
              text: 'Azimuth (º)'
            },
            ticks: {
              stepSize: 25,
              includeBounds: false
            },
            min: 0,
            max: 360
          },
          y: {
            grid: {display: false},
            stacked: false,
            title: {
              display: true,
              text: 'Elevation Angle (º)'
            },
            ticks: {
              includeBounds: false
            },
            min: null,
            max: null
          }
        },
        elements: {
          line: {
          borderWidth: 1,
          borderColor: 'rgb(0,0,0)'
        },
          point: {
            radius: 0
          }
      }
      }
    });

  }

  performHorizonTool(){
    try {
      this.calculateHorizonRings()
        .subscribe({
          error: (error) => {
            this.calculationService.showError(error);
            if (!error || error.status != 504) {
              this.progressService.horizonToolLoading = false;
            }
          }
        });
    } catch (e){
      this.progressService.horizonToolLoading = false;
    }

  }
  reproject() {
    if (!this.globalSelectionService.horizonToolLayers.active) {
      return;
    }
    this.calculateEllipsePoints();
    this.calculateInternalEllipsePoints();
    this.showEllipse();
    this.drawSummits();
    this.drawTrackLine(0);
  }

  resumePerformHorizonTool(data: HorizonDataResult){
    try {
      this.horizonData = data;
      if (this.horizonData != null){
        this.globalSelectionService.horizonToolLayers.active = true;
        this.globalSelectionService.horizonToolLayers.childLayers?.forEach(el => {
          el.showAll();
          el.status = true;
        });
        this.globalSelectionService.horizonToolLayers.childLayers[0].layers[0].expanded = true;
        this.calculateEllipsePoints();
        this.calculateInternalEllipsePoints();
        this.showEllipse();
        this.drawTrackLine(0);
        this.drawSummits();

        this.drawHorizon(this.horizonData.horizonSampRingResult);
      }
    } catch (e){
      console.error(e);
      this.progressService.horizonToolLoading = false;
    }

  }

  drawHorizonBtn(){
    if (this.progressService.horizonToolLoading == false && this.validateParameters()){
      this.progressService.horizonToolLoading = true;
      this.minScreeningAngles = [];
      this.getNearNavaidsAndExecute();
    }
  }

  calculateHorizonRings() {
    let performanceAnalysisDTO : PerformanceAnalysisDTO = new PerformanceAnalysisDTO();
    performanceAnalysisDTO.calculationSettings = CalculationSettingsModel.mapToCalculation(this.configurationService.currentConfiguration);
    performanceAnalysisDTO.calculationSettings.geometricConstraints = true;
    performanceAnalysisDTO.projectId = this.configurationService.currentConfiguration.projectId;
    performanceAnalysisDTO.rnav = RNAVModel.mapToCalculation(this.configurationService.currentConfiguration.rnav);

    performanceAnalysisDTO.horizonOptions = this.horizonModal;

    return this.calculationService.calculateHorizonToolRings(performanceAnalysisDTO);
  }

  calculateEllipsePoints() {
	  this.ellipsePoints = [];
		let distance: number = 1852 * this.horizonModal.maxDepth; // convert nautical miles to meters
		for (var azimuth:number = 0; azimuth <= 360; azimuth++) {
			let target: number[] = VicentyToolControlService.calculateDestinationPoint(this.horizonModal.centerLatitude, this.horizonModal.centerLongitude, azimuth, distance);
			let targetCoordinate: Coordinate = [target[1], target[0]];
      targetCoordinate = olProj.transform(targetCoordinate, 'EPSG:4326',this.map.getView().getProjection());
			this.ellipsePoints.push(targetCoordinate);
		}
  }
  calculateInternalEllipsePoints() {
		this.internalEllipsePoints = [];
		let distance: number = 1852 * this.horizonModal.minDepth; // convert nautical miles to meters
		for (var azimuth:number = 0; azimuth <= 360; azimuth++) {
			let target: number[] = VicentyToolControlService.calculateDestinationPoint(this.horizonModal.centerLatitude, this.horizonModal.centerLongitude, azimuth, distance);
			let targetCoordinate: Coordinate = [target[1], target[0]];
      targetCoordinate = olProj.transform(targetCoordinate, 'EPSG:4326',this.map.getView().getProjection());
			this.internalEllipsePoints.push(targetCoordinate);
		}
	}

  showEllipse(){
    // clear Horizon tool layer
    this.pointsController.horizonToolLayer.childLayers?.forEach(el => {
      el.layers.forEach(layer => {
        layer.olLayer.getSource().clear();
      })
    });
    // create features to add to layer
    let outCircle = new OlFeature({
      geometry: new Polygon([this.ellipsePoints]),
      featureType : FeatureType.HorizonTool
     });
    let inCircle = new OlFeature({
      geometry: new Polygon([this.internalEllipsePoints]),
      featureType : FeatureType.HorizonTool
     });

    let features = [outCircle, inCircle];

    // add features to layers
    let source = this.pointsController.horizonToolLayer.childLayers[0].layers
    .find((element) => element.id === 'Horizon_Tool_Layer')
    .olLayer.getSource();



   features.forEach( feat => {
      source.addFeature(feat);
    });


  }

  drawTrackLine(azimuth:number) {
    let source = this.pointsController.horizonToolLayer.childLayers[0].layers
    .find((element) => element.id === 'Horizon_Tool_Layer')
    .olLayer.getSource();
    let feature = source.getFeatureById("trackLine");
    if (feature != null){
      source.removeFeature(feature);
    }

		if (this.horizonModal.centerLatitude == null || this.horizonModal.centerLongitude == null) return;
    let distance: number = 1852 * this.horizonModal.maxDepth; // convert nautical miles to meters

		let target: number[] = VicentyToolControlService.calculateDestinationPoint(this.horizonModal.centerLatitude, this.horizonModal.centerLongitude, azimuth, distance);
    this.horizonModal.targetLatitude = target[0];
    this.horizonModal.targetLongitude = target[1];
    this.horizonModal.targetLatLonDms.fromLat(target[0]);
    this.horizonModal.targetLatLonDms.fromLon(target[1]);

		let targetCoordinate: Coordinate = [target[1], target[0]];
    targetCoordinate = olProj.transform(targetCoordinate, 'EPSG:4326',this.map.getView().getProjection());
    let centerCoordinate: Coordinate = [this.horizonModal.centerLongitude, this.horizonModal.centerLatitude];
    centerCoordinate = olProj.transform(centerCoordinate, 'EPSG:4326',this.map.getView().getProjection());

    //Creating line:
    let line = new OlFeature({
     geometry: new LineString([centerCoordinate, targetCoordinate]),
     featureType : FeatureType.HorizonTool
    });
    line.setId("trackLine");

    this.crossSectionService.feature = line;

    source.addFeature(line);
    this.globalSelectionService.horizonToolLayers.active = true;
    this.globalSelectionService.horizonToolLayers.childLayers?.forEach(el => {
      el.showAll();
      el.status = true;
    });
    this.globalSelectionService.horizonToolLayers.childLayers[0].layers[0].expanded = true;

	}

  drawSummits() {

		var filteredSummits: IndexedSummitsResult[] = [];

		if (this.horizonData != null) {
			if (this.horizonData.indexedSummitsResult != null) {
        // filter summits
				for (var tmpSummit of this.horizonData.indexedSummitsResult) {

					var distance:number = VicentyToolControlService.calculateDistance(
            this.horizonModal.centerLatitude,
            this.horizonModal.centerLongitude,
            tmpSummit.latitude,
            tmpSummit.longitude
            );

					if (distance * 0.0005399568 > this.horizonModal.minDepth) { // convert distance to nautical miles
						filteredSummits.push(tmpSummit);
					}
				}
        let source = this.pointsController.horizonToolLayer.childLayers[0].layers
        .find((element) => element.id === 'Horizon_Tool_Layer')
        .olLayer.getSource();
        for (var summit of filteredSummits){
          let coordinate: Coordinate = [summit.longitude, summit.latitude];
          coordinate = olProj.fromLonLat(coordinate,this.rcsControl.activeRCS.isactive? this.rcsControl.activeRCS.epsg : "EPSG:3857");
          //Create Point:
          let point = new OlFeature({
            geometry: new Point(coordinate),
            featureType : FeatureType.HorizonTool
          });
          let color = this.getSummitColor(summit.screeningAngle);
          let style = new Style({
            image: new Circle({
              radius: 2,
              fill: new Fill({
                  color: color
              })
          })
          });
          point.setStyle(style);
          source.addFeature(point);
        }
			}
		}
	}

  private getSummitColor(screeningAngle: number) : ColorLike{
    if(screeningAngle > 6){
			return 'rgba(170, 0, 0, 0.5)';
		}
		else if(screeningAngle > 4){
			return 'rgba(255, 25, 25, 0.5)';
		}
		else if(screeningAngle > 2){
			return 'rgba(255, 136, 17, 0.5)';
		}
		else if(screeningAngle > 0){
			return 'rgba(255, 255, 0, 0.5)';
		}
		else{
			return 'rgba(0, 255, 255, 0.5)';
		}
  }

  drawHorizon(horizonSampRingResults : HorizonSampRingResult[] ) : void {

		var results : HorizonSampRingResult[] = [];

		for (let horizonSampRingResult of horizonSampRingResults) {
			if (horizonSampRingResult != null) {
				results.push(horizonSampRingResult);
			}
		}

		for (let i: number = 0; i < results.length; i++) {
			let value: number = (255.0 * (i / (results.length - 1)));
			results[i].color = [value, value, value, 1];
		}

		this.refreshHorizons(results, true, this.minScreeningAngles);

		// if (viewer != null) {
		// 	viewer.refresh();
		// }
	}

  /**
	 * gets the max value from the list of results
	 *
	 * @param results2
	 * @return
	 */
	private getMaxDeepValue(results2: HorizonSampRingResult[]) : number {
		let max : number = 0.0;

		for (let tmp of results2) {
			if (tmp.depth > max)
				max = tmp.depth;
		}

		return max;
	}

    refreshHorizons( results: HorizonSampRingResult[] ,refresh: boolean, minScreeningAngles: any[]) : void {
		var minY: number = null;
		var maxY: number = null;

    var maxAngleToUse: number;
    var minAngleToUse: number;

		var maxDeep: number = this.getMaxDeepValue(results);
		maxDeep -= this.horizonModal.minDepth;
		var startColor: number[] = [0, 0, 255];
		var colorResult: number[] = null;
    var dataset = [];
		for (let result of results) {

			if (result == null){
        continue;
      }

      // gets the current deep
			var currentDeep: number = result.depth;
			currentDeep -= this.horizonModal.minDepth;

			var percent: number = currentDeep / maxDeep;

			// the percentage of depth already covered
			try {// determines the color according to the depth
				if (percent <= 0.5) {

					/*
					 * R = 0 -> 255 G = 0 -> 255 B = 0
					 */
					colorResult = [0, Math.floor(255 * (percent * 2)), Math.floor(255 - (255 * (percent * 2)))];

				} else {
					percent -= 0.5;
					/*
					 * R = 0 G = 0 -> 255 B = 255 -> 0
					 */
					colorResult =  [Math.floor(255 * (percent * 2)), Math.floor(255 - (255 * (percent * 2))), 0];
				}
			} catch (e) {
				colorResult = startColor;
      }

      var seriesPoints = [];

			var pointResults: SampPointResult[] = result.sampPointResult;

			for (let i: number = 0; i < pointResults.length; i++) {// calculates xy
				// points in the
				// samplepoints
				if (pointResults[i] != null) {
					var valueY: number = pointResults[i].screeningAngle;
          seriesPoints.push(valueY);

					if ((minY == null) || (valueY < minY)) {
						minY = valueY;
					}

					if ((maxY == null) || (valueY > maxY)) {
						maxY = valueY;
					}
				}
			}
      if (minY != null && maxY != null){
        minAngleToUse = minY;
        maxAngleToUse = maxY;
      }



			var summitColor: ColorLike =  'rgb(' + colorResult.join(',')  + ')';

      dataset.push( {
        data: seriesPoints,
        backgroundColor: summitColor,
        fill: 'start',
        clip: -2
      });

		}

		var minAngle: number = null;
		var maxAngle: number = null;

    //temp values

		if (this.useScreening && minScreeningAngles.length > 0) {
			var vertAngle: number = null;
			for (let angle of minScreeningAngles) {
				if ((vertAngle == null) || (angle.verticalangle != null && angle.verticalangle > vertAngle)) {
					vertAngle = angle.verticalangle;
				}
			}
			if (results != null) {
				if (vertAngle == null) {
					for (let tmpRing of results) {
            if (tmpRing.sampPointResult != null)
              for (let tmpSample of tmpRing.sampPointResult) {

                if (minAngle == null) {
                  minAngle = tmpSample.screeningAngle;
                }

                if (maxAngle == null) {
                  maxAngle = tmpSample.screeningAngle;
                }

                if (tmpSample.screeningAngle < minAngle) {
                  minAngle = tmpSample.screeningAngle;
                }

                if (tmpSample.screeningAngle > maxAngle)
                  maxAngle = tmpSample.screeningAngle;
              }
          }
					vertAngle = maxAngle;
				} else {
					for (let tmpRing of results) {
            if (tmpRing.sampPointResult != null)
              for (let tmpSample of tmpRing.sampPointResult) {

                if (minAngle == null) {
                  minAngle = tmpSample.screeningAngle;
                }

                if (tmpSample.screeningAngle < minAngle) {
                  minAngle = tmpSample.screeningAngle;
                }

              }
          }
				}
			}
			if (minAngle != null && vertAngle != null) {
        minAngleToUse = minAngle;
        maxAngleToUse = vertAngle;
      }
      for (let angle of minScreeningAngles) {
        const data =
          [{
             x: angle.minangle,
             y: vertAngle
          }, {
            x: angle.maxangle,
            y: vertAngle
         }];
        dataset.unshift( { // push to list beginning
          label: "minScreenAngle",
          data: data,
          backgroundColor: 'rgb(0,0,0)', // black
          fill: 'start',
          clip: -2
        });
      }

		} else {
			if (results != null) {
				for (let tmpRing of results) {
					if (tmpRing.sampPointResult != null)
						for (let tmpSample of tmpRing.sampPointResult) {

							if (minAngle == null) {
								minAngle = tmpSample.screeningAngle;
              }

							if (maxAngle == null) {
								maxAngle = tmpSample.screeningAngle;
              }

							if (tmpSample.screeningAngle < minAngle) {
								minAngle = tmpSample.screeningAngle;
							}

							if (tmpSample.screeningAngle > maxAngle)
								maxAngle = tmpSample.screeningAngle;

						}
				}
			}
			if (minAngle != null && maxAngle != null) {
        minAngleToUse = minAngle;
        maxAngleToUse = maxAngle;
      }

		}

    const labels = HorizonToolService.rangeByStep(0.0,359.7,0.3);
    const data = {
      labels: labels,
      datasets: dataset,
    };

    this.chart.data = data;
    this.chart.options.scales.y.min = minAngleToUse;
    this.chart.options.scales.y.max = maxAngleToUse;
    this.chart.options.scales.x.max = 360;
    this.chart.update();

    this.progressService.horizonToolLoading = false;
	}

  // use start, end and step with same decimals length
  public static rangeByStep(start: number, end: number, step: number): number[] {
    if (end === start || step === 0) {
        return [start];
    }
    if (step < 0) {
        step = -step;
    }

    const stepNumOfDecimal = step.toString().split(".")[1]?.length || 0;
    const endNumOfDecimal = end.toString().split(".")[1]?.length || 0;
    const maxNumOfDecimal = Math.max(stepNumOfDecimal, endNumOfDecimal);
    const power = Math.pow(10, maxNumOfDecimal);
    const diff = Math.abs(end - start);
    const count = Math.trunc(diff / step + 1);
    step = end - start > 0 ? step : -step;

    const intStart = Math.trunc(start * power);
    return Array.from(Array(count).keys())
        .map(x => {
            const increment = Math.trunc(x * step * power);
            const value = intStart + increment;
            return Math.trunc(value) / power;
        });
  }

  cancelWindow():void{
    this.active = false;
    this.pointsController.horizonToolLayer.childLayers?.forEach(el => {
      el.layers.forEach(layer => {
        layer.olLayer.getSource().clear();
      })
    });
    unByKey(this.eventKey); // include in switch function
    this.chart?.destroy();
    this.chart = null;
    this.clicked = false;
  }

  hideWindow():void{
    this.active = false;
    unByKey(this.eventKey); // include in switch function
  }
}
